import TripIcon2 from "@/assets/SVG/TripIcon2";
import TripIcon24 from "@/assets/SVG/TripIcon24";
import CalendarIcon24 from "@/assets/SVG/calendarIcon24";
import LocationIcon from "@/assets/SVG/locationIcon24";
import UserCheckIcon from "@/assets/SVG/userCheckIcon";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getUserInArea, togglePatientReceptionStatus } from "../../api/area";
import { Loader } from "../loader";
import { Modal } from "../modal";
import HistoryArea from "./historyArea";
import ManageMembers from "./manageMembers/ManageMembers";

export default function DashboardArea2({ data }) {
  const [members, setMembers] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [stopReception, setStopReception] = useState(false);

  useEffect(() => {
    setStopReception(data[0].areas[0].stopReception);
  }, [data[0].areas[0].stopReception]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    getUserInArea(data[0]?.areas[0]?.id, "returnPresenceList=true")
      .then((res) => setMembers(res))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!members) fetchData();
  }, [members]);

  const md = useMediaQuery("(max-width:450px)");
  const [modules, setModules] = useState([]);
  useEffect(() => {
    if (data[0].areas[0].modules) {
      setModules(
        [
          ...data[0].areas[0].modules,
          ...[
            data[0].areas[0]?.dispatchers?.length > 0
              ? { moduleName: "پذیرش" }
              : undefined,
            data[0].areas[0]?.insurancers?.length > 0
              ? { moduleName: "بیمه" }
              : undefined,
            data[0].areas[0]?.laboratoryManager?.length > 0
              ? { moduleName: "آزمایشگاه" }
              : undefined,
            data[0].areas[0]?.pharmacyManagers?.length > 0
              ? { moduleName: "داروخانه" }
              : undefined,
            data[0].areas[0]?.trainers?.length > 0
              ? { moduleName: "آموزش" }
              : undefined,
            data[0].areas[0]?.equipmentManager?.length > 0
              ? { moduleName: "تجهیزات" }
              : undefined,
          ],
        ].filter((itr) => itr !== undefined),
      );
    }
  }, [data[0].areas[0].modules]);

  return (
    <>
      <Box
        mt="20px"
        display="flex"
        flexDirection={md ? "column" : "row"}
        gap="10px"
      >
        {data && (
          <>
            <Modal
              icon={<TripIcon24 />}
              title={"پروژه"}
              width="calc(min(100%, 700px))"
            >
              <Grid
                display={"flex"}
                flexDirection={"column"}
                gap={"10px"}
                mt={"20px"}
              >
                <Grid display={"flex"} justifyContent={"space-between"}>
                  <Grid display={"flex"} alignItems={"center"} gap={"5px"}>
                    <TripIcon2 />
                    <Typography color={"text.primary"}>نام اردو</Typography>
                  </Grid>
                  <Typography color={"text.primary"}>{data[0].name}</Typography>
                </Grid>
                <Grid display={"flex"} justifyContent={"space-between"}>
                  <Grid display={"flex"} alignItems={"center"} gap={"5px"}>
                    <LocationIcon />
                    <Typography color={"text.primary"}>نام منطقه</Typography>
                  </Grid>
                  <Typography color={"text.primary"}>
                    {data[0].areas[0].name}
                  </Typography>
                </Grid>
                {data[0].areas[0].startAt && (
                  <Grid display={"flex"} justifyContent={"space-between"}>
                    <Grid display={"flex"} alignItems={"center"} gap={"5px"}>
                      <CalendarIcon24 />
                      <Typography color={"text.primary"}>
                        بازه برگزاری
                      </Typography>
                    </Grid>
                    <Typography color={"text.primary"}>
                      {`${data[0].areas[0].startAt.split(" ", 2)[0]} - ${
                        data[0].areas[0].endAt.split(" ", 2)[0]
                      } `}
                    </Typography>
                  </Grid>
                )}
                <Grid display={"flex"} justifyContent={"space-between"}>
                  <Grid display={"flex"} alignItems={"center"} gap={"5px"}>
                    <UserCheckIcon />
                    <Typography color={"text.primary"}>بخش‌های اردو</Typography>
                  </Grid>
                  <Typography
                    color={"text.primary"}
                    variant="caption"
                    maxWidth={"300px"}
                  >
                    {modules.map((m) => m.moduleName).join(" - ")}
                  </Typography>
                </Grid>

                <Grid display={"flex"} justifyContent={"space-between"}>
                  <Grid display={"flex"} alignItems={"center"} gap={"5px"}>
                    <UserCheckIcon />
                    <Typography color={"text.primary"}>
                      وضعیت پذیرش بیمار
                    </Typography>
                  </Grid>
                  <Typography
                    color={stopReception ? "text.error" : "text.main"}
                  >
                    {stopReception === true ? "متوقف" : "در جریان"}
                  </Typography>
                </Grid>
                <Grid display={"flex"} justifyContent={"space-between"}>
                  <Grid display={"flex"} alignItems={"center"} gap={"5px"}>
                    <UserCheckIcon />
                    <Typography color={"text.primary"}>
                      وضعیت نهایی‌سازی شده
                    </Typography>
                  </Grid>
                  <Typography
                    color={
                      data[0].areas[0].finished ? "text.main" : "text.error"
                    }
                  >
                    {data[0].areas[0].finished === true
                      ? "نهایی‌سازی شده"
                      : "نیازمند تکمیل اطلاعات"}
                  </Typography>
                </Grid>

                {data[0]?.areas[0]?.cityId && (
                  <Grid
                    display={"flex"}
                    flexDirection={md ? "column" : "row"}
                    gap={"10px"}
                    width={"100%"}
                    sx={{ marginTop: "20px" }}
                  >
                    <Button
                      onClick={() =>
                        navigate(`/complete-area/${data[0]?.areas[0]?.id}`)
                      }
                      sx={{ width: md ? "100%" : "25%" }}
                      variant="contained"
                    >
                      ویرایش اردو
                    </Button>
                    <Button
                      onClick={() =>
                        navigate(`/manage-notifs/${data[0]?.areas[0]?.id}`)
                      }
                      sx={{ width: md ? "100%" : "25%" }}
                      color="secondary"
                      variant="contained"
                    >
                      مدیریت اعلانات
                    </Button>
                    <Button
                      onClick={async () => {
                        setLoading(true);
                        togglePatientReceptionStatus(data[0]?.areas[0]?.id)
                          .then(() => {
                            toast.success(
                              "تغییر وضعیت پذیرش با موفقیت انجام شد",
                            );
                            setStopReception(!stopReception);
                          })
                          .catch(() => {})
                          .finally(() => setLoading(false));
                      }}
                      sx={{ width: md ? "100%" : "45%" }}
                      color="error"
                      variant="contained"
                    >
                      تغییر وضعیت پذیرش بیمار
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Modal>
            <Grid
              sx={{ width: md ? "100%" : "calc(100% - 700px)" }}
              display={"flex"}
            >
              <HistoryArea dataArea={data} open={true} setOpen={() => {}} />
            </Grid>
          </>
        )}
      </Box>
      {loading && <Loader />}
      <ManageMembers data={members} areaId={data[0].areas[0].id} />
    </>
  );
}
